import {
  createApiRef,
  DiscoveryApi,
  FetchApi,
} from '@mainstage/core-plugin-api';

export type EventTopicSchema = {
  id: string;
  namespace: string;
  name: string;
  description: string;
  schema: Record<string, unknown>;
};

export type NotificationKindSchema = {
  kind: string;
  description: string;
  affectedModules: string[];
  supportedRecipientTypes: string[];
  triggerTopicIds: string[];
  bodySchema?: Record<string, unknown>;
  additionalDocs?: { title: string; content: string }[];
};

export interface DeveloperToolsApi {
  getEventTopics(): Promise<{ topics: EventTopicSchema[] }>;
  getNotificationKinds(): Promise<{ kinds: NotificationKindSchema[] }>;
}

export const developerToolsApiRef = createApiRef<DeveloperToolsApi>({
  id: 'wb-developer-tools',
});

export class DeveloperToolsClient implements DeveloperToolsApi {
  private readonly discoveryApi: DiscoveryApi;
  private readonly fetchApi: FetchApi;

  constructor(options: { discoveryApi: DiscoveryApi; fetchApi: FetchApi }) {
    this.discoveryApi = options.discoveryApi;
    this.fetchApi = options.fetchApi;
  }

  async getEventTopics(): Promise<{ topics: EventTopicSchema[] }> {
    const baseUrl = await this.discoveryApi.getBaseUrl('events');
    const response = await this.fetchApi.fetch(`${baseUrl}/topics`);
    if (!response.ok) {
      throw new Error(`Failed to fetch event topics: ${response.statusText}`);
    }
    return response.json();
  }

  async getNotificationKinds(): Promise<{ kinds: NotificationKindSchema[] }> {
    const baseUrl = await this.discoveryApi.getBaseUrl('notifications');
    const response = await this.fetchApi.fetch(`${baseUrl}/kinds`);
    if (!response.ok) {
      throw new Error(
        `Failed to fetch notification kinds: ${response.statusText}`,
      );
    }
    return response.json();
  }
}
